var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBitget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1011 3.36323C16.6024 2.86193 17.287 2.55469 17.9715 2.55469H22.591C23.1516 2.55469 23.4642 3.23925 23.0923 3.67586L13.9828 13.4107H19.0388L24.1542 18.8387H13.9828L24.1542 29.6946H18.0416C17.3571 29.6946 16.6671 29.382 16.1712 28.8861L5.87042 17.9008C4.93252 16.9036 4.93252 15.4051 5.87042 14.4079L16.1658 3.42791L16.1011 3.36323Z",
    fill: "#1DA2B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2611 39.6791C29.7598 40.1804 29.0752 40.4876 28.3906 40.4876H23.7712C23.2106 40.4876 22.898 39.803 23.2699 39.3664L32.3794 29.6316H27.3234L22.208 24.2036H32.3794L22.2188 13.3477H28.3313C29.0159 13.3477 29.7059 13.6603 30.2018 14.1562L40.4972 25.1362C41.4351 26.1333 41.4351 27.6318 40.4972 28.629L30.1964 39.609L30.2611 39.6737V39.6791Z",
    fill: "#1DA2B4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitget);
export default __webpack_public_path__ + "static/media/bitget.567066f1c2418a97cc477b7c0ee2fd00.svg";
export { ForwardRef as ReactComponent };